import React from 'react'
import Helmet from 'react-helmet'
import Header from '../header'
import Footer from '../footer'

const Layout = ({children}) => {
    return (
        <>
            <Helmet>
                <title>Millennium Garages - Flex Daily Account Management</title>
                <meta name="description" content="Millennium Garages - Flex Daily Account Management" />
            </Helmet>
            <div className="layout-wrapper">
                <Header />
                <div className="main_wrapper">
                    {children}
                </div>
                <Footer />
            </div>
        </>
    )
}

export default Layout